module.exports = __webpack_public_path__ + "img/heroBg.e8af3a81.png";